package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import io.ktor.client.*

class SportApi(private val client: HttpClient) {

    suspend fun getAllSports(): ApiResponse<List<SportDto>> {
        return client.apiGet("v1/sports")
    }

    suspend fun getAttributes(sportId: String): ApiResponse<List<SportAttributeDto>> {
        return client.apiGet("v1/sports/$sportId/attributes")
    }

    suspend fun getPositions(sportId: String): ApiResponse<List<SportPositionDto>> {
        return client.apiGet("v1/sports/$sportId/positions")
    }

    suspend fun getStatTypes(sportId: String): ApiResponse<List<SportStatTypeDto>> {
        return client.apiGet("v1/sports/$sportId/stat-types")
    }

    suspend fun getFormations(sportId: String): ApiResponse<List<FormationDto>> {
        return client.apiGet("v1/sports/$sportId/formations")
    }
}
